"use strict";
/**
 * This file was automatically generated by joi-to-typescript
 * Do not modify this file manually
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./AddressValidationTangleRequest"), exports);
__exportStar(require("./AwardAppParticipantTangleRequest"), exports);
__exportStar(require("./AwardCreateTangleRequest"), exports);
__exportStar(require("./AwardFundTangleRequest"), exports);
__exportStar(require("./MetadataNftTangleRequest"), exports);
__exportStar(require("./NftBidTangleRequest"), exports);
__exportStar(require("./NftPurchaseTangleRequest"), exports);
__exportStar(require("./NftSetForSaleTangleRequest"), exports);
__exportStar(require("./ProposalApproveTangleRequest"), exports);
__exportStar(require("./ProposalCreateTangleRequest"), exports);
__exportStar(require("./ProposalVoteTangleRequest"), exports);
__exportStar(require("./SpaceCreateTangleRequest"), exports);
__exportStar(require("./SpaceEditMemberTangleRequest"), exports);
__exportStar(require("./SpaceJoinTangleRequest"), exports);
__exportStar(require("./SpaceLeaveTangleRequest"), exports);
__exportStar(require("./TokenClaimTangleRequest"), exports);
__exportStar(require("./TokenStakeTangleRequest"), exports);
__exportStar(require("./TokenTradeTangleRequest"), exports);
